import DeleteButton from 'components/common/delete-icon-button';
import { Input } from 'components/elements';
import { useFormState } from 'components/elements/form';
import {
  FullContainer,
  HalfContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import VisaFlightTable from './visa-flight-table';

interface Props {
  parentIndex: number;
  onRemove: () => void;
  fieldLength?: number;
  isParentError: boolean;
}

const parentName = 'visaDocumentFlights' as const;

export default function VisaDocumentFlightSchedule(props: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();

  const name = `${parentName}.${props.parentIndex}` as const;

  return (
    <FullContainer
      style={{
        overflow: 'auto',
        maxHeight: 'calc(100dvh - 250px',
      }}
    >
      <SectionContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`${name}.name`}
            label={t('common:schedule_name')}
            required
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name={`${name}.description`}
            label={t('common:description')}
          />
        </HalfContainer>
        {(props.fieldLength || 0) > 1 && editable && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: '10px',
            }}
          >
            <DeleteButton
              onClick={props.onRemove}
              rootStyle={{ height: '32px' }}
            />
          </div>
        )}
      </SectionContainer>
      <SeparatorVertical $margin={16} />
      <VisaFlightTable parentIndex={props.parentIndex} />
    </FullContainer>
  );
}
